import {
    createSlice
} from '@reduxjs/toolkit';
import LandingPageServices from '../services/LandingPageServices';
import _ from 'lodash';
import CommonUtil from '../common/CommonUtil';
import {
    getAllLeagueId,
    getAllSsportCodes,
    combinedSportLeagueData,
    combinedESportData
} from '../components/LandingPageComponent/CommonComponent/CommonUtils';

const initialState = {
    loading: false,
    hasErrors: false,
    top: [],
    leagues: [],
    eSports: [],
    casino: [],
    fetchBannersDone: false,
    isFromLandingPage: false,
    isCheckedNoEvent: false,
    leftSideBanners: [],
    rightSideBanners: [],
    leaguesTemp: [],
    eSportsTemp: [],
    fetchOddsDone: false,
}

export const LandingPageSlice = createSlice({
    name: 'LandingPageSlice',
    initialState: initialState,
    reducers: {
        // Banner
        fetchBannersStart: state => {
            state.loading = true;
            state.fetchBannersDone = false;
        },

        fetchBannersSuccess: (state, { payload }) => {
            state.loading = false;
            state.hasError = false;
            if (payload) {
                state.top = payload.top;
                state.leaguesTemp = payload.leagues;
                state.eSportsTemp = payload.eSports;
                state.casino = payload.casino;
                state.sideBanners = payload.side;
                state.fetchBannersDone = true;
            }
        },

        fetchBannersFailure: state => {
            state.loading = false;
            state.hasErrors = true;
        },

        // Odds
        fetchOddsStart: state => {
            state.loading = true;
            state.fetchOddsDone = false;
        },

        fetchOddsSuccess: (state, { payload }) => {
            state.loading = false;
            state.hasError = false;
            if (payload) {
                state.leagues = payload.newLeaguesData;
                state.eSports = payload.newEsportsData;
            }
            state.fetchOddsDone = true;
        },

        fetchOddsFailure: state => {
            state.loading = false;
            state.hasErrors = true;
        },

        updateIsFromLandingPage: (state, { payload }) => {
            state.isFromLandingPage = payload
        },

        updateIsCheckedNoEvent: (state, { payload }) => {
            state.isCheckedNoEvent = payload
        },

        // Side Banner
        fetchSideBannersStart: state => {
            state.loading = true;
        },

        fetchSideBannersSuccess: (state, { payload }) => {
            state.loading = false;
            state.hasError = false;
            if (payload) {
                state.leftSideBanners =  payload.left;
                state.rightSideBanners =  payload.right;
            }
        },

        fetchSideBannersFailure: state => {
            state.loading = false;
            state.hasErrors = true;
        },
    }
});

export const {
    fetchSideBannersStart,
    fetchSideBannersSuccess,
    fetchSideBannersFailure,
    fetchBannersStart,
    fetchBannersSuccess,
    fetchBannersFailure,
    fetchOddsStart,
    fetchOddsSuccess,
    fetchOddsFailure,
    updateIsFromLandingPage,
    updateIsCheckedNoEvent
  } = LandingPageSlice.actions;

export const fetchBanners = () => {
    const params = {
        lang: CommonUtil.toLocaleCode(CommonUtil.getCurrentLang()),
        c: CommonUtil.getCountry()
    }
    return async (dispatch) => {
        dispatch(fetchBannersStart());
        try {
            const response = await LandingPageServices.fetchBanners(params).then(res => {
                return res.data;
            }).catch(e => {
                dispatch(fetchBannersFailure());
            });
            dispatch(fetchBannersSuccess(response))
        } catch (error) {
            dispatch(fetchBannersFailure())
        }
    }
}

export const fetchOdds = () => {
    return async (dispatch, getState) => {
        let temp = getAllLeagueId(getState().LandingPageSlice.leaguesTemp || []);
        const {leagueIds, sportIds} = temp;
        let esportCodes = getAllSsportCodes(getState().LandingPageSlice.eSportsTemp || []);
        if (_.isEmpty(leagueIds) && _.isEmpty(sportIds) && _.isEmpty(esportCodes)) {
            return;
        }
        const params = {
            sp: sportIds,
            ls: leagueIds,
            escs: esportCodes,
            c: CommonUtil.getCountry(),
            lang: CommonUtil.getCurrentLang()
        }
        try {
            const response = await LandingPageServices.fetchOdds(params).then(res => {
                let result = {};
                const oddsData = res.data;
                if (oddsData) {
                    // Combined odds data
                    const newLeaguesData = combinedSportLeagueData(oddsData, JSON.parse(JSON.stringify(getState().LandingPageSlice.leaguesTemp)));
                    const newEsportsData = combinedESportData(oddsData,  JSON.parse(JSON.stringify(getState().LandingPageSlice.eSportsTemp)));
                    result = {
                        newLeaguesData: newLeaguesData,
                        newEsportsData: newEsportsData
                    }
                }
                return result;
            }).catch(e => {
                dispatch(fetchOddsFailure());
            });
            dispatch(fetchOddsSuccess(response))
        } catch (error) {
            dispatch(fetchOddsFailure())
        }
    }
}

export const fetchSideBanners = () => {
    const params = {
        lang: CommonUtil.toLocaleCode(CommonUtil.getCurrentLang()),
        c: CommonUtil.getCountry()
    }
    return async (dispatch) => {
        try {
            const response = await LandingPageServices.fetchSideBanners(params).then(res => {
                return res.data;
            }).catch(e => {
                dispatch(fetchSideBannersFailure());
            });
            dispatch(fetchSideBannersSuccess(response))
        } catch (error) {
            dispatch(fetchSideBannersFailure())
        }
    }
}

export default LandingPageSlice.reducer;


// WEBPACK FOOTER //
// ./src/app/slices/LandingPageSlice.js